export default {
  relatorio: {
    values: null,
    options: [],
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/components/resume/resume-form.js